import {
  Arrange,
  Button,
  Container,
  Icon,
  SvgAlertTriangle,
  Text,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import {
  GLOBAL_CONTENT_LIMIT_BANNER_UPGRADE_CLICKED,
  STORAGE_INCENTIVE_INVITE_TEAMMATES_CTA_CLICKED,
} from 'constants/events';
import { TEAM_INVITE_MODAL } from 'constants/modalTypes';
import { WORKSPACE_PLAN_BUSINESS } from 'constants/workspacePlans';
import { requestUpgrade } from 'creators/upgrades';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import * as analytics from '../../../utilities/analytics';
import { GLOBAL_CONTENT_LIMIT_BANNER } from '../constants';
import { MemberVideoLimits } from '../types';

import styles from './styles.module.less';

interface Props {
  memberVideoLimits: MemberVideoLimits;
  children: JSX.Element;
}

function GlobalContentLimitBanner({
  memberVideoLimits,
  children,
}: Props): JSX.Element {
  const dispatch = useDispatch();
  const workspace = useGetSelectedWorkspace();

  function handleUpgrade() {
    dispatch(
      requestUpgrade({
        analyticsEvent: GLOBAL_CONTENT_LIMIT_BANNER_UPGRADE_CLICKED,
        selectedWorkspace: workspace,
        minPlanForFeature: WORKSPACE_PLAN_BUSINESS,
      })
    );
  }

  function handleInviteTeammates() {
    dispatch(openModal(TEAM_INVITE_MODAL));

    analytics.track(STORAGE_INCENTIVE_INVITE_TEAMMATES_CTA_CLICKED, {
      source: GLOBAL_CONTENT_LIMIT_BANNER,
    });
  }

  return (
    <div className={styles.globalBannerContainer}>
      <Container
        width="100%"
        position="sticky"
        top={0}
        paddingX="2rem"
        paddingY="medium"
        backgroundColor="yellowLight"
      >
        <Arrange justifyContent="space-between" gap="small">
          <Arrange justifyContent="start" gap="small">
            <Icon icon={<SvgAlertTriangle />} size="large" />
            <Text>
              <b>
                You&apos;ve reached your {memberVideoLimits.limit} video limit.
              </b>{' '}
              Increase your video storage by inviting teammates or upgrading
              your plan.
            </Text>
          </Arrange>
          <Arrange justifyContent="end" gap="small">
            <Button onClick={handleInviteTeammates}>Invite Teammates</Button>
            <Button onClick={handleUpgrade}>Upgrade Plan</Button>
          </Arrange>
        </Arrange>
      </Container>
      {children}
    </div>
  );
}

export default GlobalContentLimitBanner;
